import axios from '../../config/axios';
import apiPaths from '../apiPaths';

// this is a function that calls the api to get the customer portal availability, it returns a boolean
const onGetCustomerPortalAvailability = () => axios.get(`${apiPaths.stripeBase}/customer-portal-availability`);

// this is a function that calls the api to create the customer portal url, it returns a string
const onCreateCustomerPortalSession = () => axios.post(`${apiPaths.stripeBase}/customer-portal-session`);

export { onGetCustomerPortalAvailability, onCreateCustomerPortalSession };
